import { useEffect, useRef } from 'react'

import { Input, InputRef } from 'antd'

interface Props {
    value: string
    focus: boolean
    onFocus: () => void
    onChange: (value: string) => void
    onMoveFocus: (direction: 'previous' | 'next') => void
    onPasteCode: (code: string) => void
}

const DigitInput = (props: Props) => {
    const { value, focus, onFocus, onChange, onMoveFocus, onPasteCode } = props

    const ref = useRef<InputRef>()

    useEffect(() => {
        if (focus) {
            ref.current.focus()
        }
    }, [focus])

    return (
        <Input
            data-testid="digit-input"
            ref={ref}
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="[0-9]*"
            onKeyDown={(e) => {
                const backspaceUsed = e.code === 'Backspace'
                const arrowUsed = e.code === 'ArrowLeft' || e.code === 'ArrowRight'

                if (arrowUsed || (backspaceUsed && !value)) {
                    e.preventDefault()
                    const direction = e.code === 'ArrowLeft' || backspaceUsed ? 'previous' : 'next'
                    onMoveFocus(direction)
                }
            }}
            onPaste={(e) => {
                const pastedDigits = e.clipboardData.getData('text').replace(/\D/g, '')
                if (pastedDigits) {
                    e.preventDefault()
                    onPasteCode(pastedDigits)
                }
            }}
            value={value}
            onFocus={onFocus}
            onChange={(e) => {
                // When a user types a new number when there is already one, we replace it.
                const valueLength = e.target.value?.length
                const newValue = e.target.value?.slice(valueLength - 1, valueLength)

                const validValue = !isNaN(parseInt(newValue)) || newValue === ''
                if (validValue) {
                    onChange(newValue)
                }
            }}
            className="mx-2 h-10 text-center"
        />
    )
}

export default DigitInput
